import { render } from "./section-banner.vue?vue&type=template&id=337c4e4d&scoped=true"
import script from "./section-banner.vue?vue&type=script&lang=js"
export * from "./section-banner.vue?vue&type=script&lang=js"

import "./section-banner.vue?vue&type=style&index=0&id=337c4e4d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337c4e4d"]])

export default __exports__